import React from 'react'
import { MDBContainer, MDBRow, 
    MDBCol, MDBCardBody, MDBCard, MDBIcon } from 'mdbreact'
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import ProgressiveImage from 'react-progressive-image';

const FeaturedReviews = ({featuredReviews}) => {
    
    const arrowStyle = {
        padding: `1rem`,
        color: `#fff`,
        cursor: `pointer`,
        background: `#000`
    }

    const reviewsData = featuredReviews.map((reviews)=>
        <>
        <MDBCol size="12" md="6" lg="6" className="my-5">
            <MDBCard>
                <MDBCardBody className="text-center p-4">
                    <MDBRow>
                        <MDBCol className="align-self-center" lg="4" md="4" size="12">
                            <ProgressiveImage src={reviews.image.url} placeholder={reviews.image.formats.thumbnail.url}>
                                {(src, loading) => <img 
                                src={src}
                                style={{ filter: loading && "blur(10px)" }} 
                                className="rounded-circle w-100" alt=""/>}
                            </ProgressiveImage>
                        </MDBCol>
                        <MDBCol md="8" lg="8" size="12" className="pl-lg-0 pl-md-0 align-self-center pt-3 pt-lg-0 pt-md-0">
                            <div className="d-flex flex-column">
                                <h5 className="h5-responsive font-weight-bold">
                                    {reviews.name}
                                </h5>
                                <span className="h6-responsive">
                                    <MDBIcon icon="quote-left" className="mr-2"/>
                                    {reviews.review}
                                </span>
                            </div>
                        </MDBCol> 
                    </MDBRow>
                </MDBCardBody>
            </MDBCard>
        </MDBCol>
        </>
    )

    return (
        <>
            <MDBContainer className="my-5 py-5">
                <h1 className="font-weight-bold menu-mobile-style display-4">
                    Product Reviews
                </h1>
                <p className="lead">
                    What they say about our products
                </p>
                <MDBRow className="px-3 px-lg-0 px-md-0">
                    <Carousel
                        autoPlay={5000}
                        clickToChange 
                        addArrowClickHandler 
                        infinite 
                        arrowLeft={<MDBIcon style={arrowStyle} icon="arrow-left"/>} arrowRight={<MDBIcon style={arrowStyle} icon="arrow-right"/>} centered arrows>
                        {reviewsData}
                    </Carousel>
                </MDBRow>
            </MDBContainer>
        </>
    )
}

export default FeaturedReviews
